import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { NgxTolgeeModule } from '@tolgee/ngx';

@Component({
	selector: 'au-empty-placeholder',
	templateUrl: './empty-placeholder.component.html',
	styleUrls: ['./empty-placeholder.component.scss'],

	imports: [
		CommonModule,
		MatIconModule,
		MatButtonModule,
		MatTooltipModule,
		RouterModule,
		NgxTolgeeModule,
	],
})
export class EmptyPlaceholderComponent {
	@Input()
	placeholderPath = './assets/img/maskot/no-work-entity.svg';

	@Input()
	placeholderStyles: CSSStyleSheet;

	@Input()
	placeholderClass = '';

	@Input()
	title: string;

	@Input()
	titleClass: string;

	@Input()
	description: string;

	@Input()
	descriptionClass: string;

	@Input()
	label: string;

	@Input()
	buttonText: string | undefined;

	@Input()
	iconName: string | undefined;

	@Input()
	width = 265;

	@Input()
	link: string;

	@Input()
	linkText: string;

	@Input()
	disableButton = false;

	@Input()
	disabledButtonTooltipText: string = null;

	@Input()
	buttonTooltipText: string = null;

	@Input()
	list: string[];

	@Output()
	buttonClicked = new EventEmitter<void>();

	callToAction() {
		this.buttonClicked.emit();
	}

	get tooltipText() {
		return this.disableButton ? this.disabledButtonTooltipText : this.buttonTooltipText;
	}
}
